import { useEffect } from "react";

export default function PrivacyPolicy() {
  useEffect(() => { document.title = "מדיניות פרטיות | topiqz"; }, []);
  return (
    <main id="main-content" className="privacy-page" dir="rtl">
      <nav aria-label="חזרה לדף הבית" className="privacy-back-nav">
        <a href="/">← חזרה לדף הראשי</a>
      </nav>
      <div className="privacy-content">
        <h1>מדיניות פרטיות – אפליקציית לימוד אנגלית לילדים</h1>

        <p>
          ברוכים הבאים! האפליקציה היא פרויקט לימודי-חינוכי המופעל על ידי{" "}
          <strong>אדם פרטי בישראל</strong> (להלן: &ldquo;מפעיל האפליקציה&rdquo;).
          המטרה שלי היא לעזור לילדים דוברי עברית לשפר את אוצר המילים שלהם
          באנגלית בצורה מהנה ובטוחה.
        </p>
        <p>
          הפרטיות שלכם ושל ילדיכם חשובה לי מאוד. מסמך זה מסביר איזה מידע נאסף,
          כיצד משתמשים בו ואיך אני שומר עליו.
        </p>

        <h2>1. מי מנהל את האפליקציה?</h2>
        <p>
          האפליקציה אינה שייכת לחברה או לעסק רשום, אלא מופעלת כיוזמה אישית ללא
          מטרות רווח. ניתן ליצור קשר בכל שאלה בנושא פרטיות בכתובת המייל:{" "}
          <a href="mailto:perestom@gmail.com">perestom@gmail.com</a>.
        </p>

        <h2>2. איזה מידע אנחנו אוספים?</h2>
        <p>כדי שהאפליקציה תפעל, אנחנו אוספים את המידע הבא:</p>
        <ul>
          <li>
            <strong>הורים:</strong> שם וכתובת אימייל (מתקבלים דרך התחברות עם
            חשבון Google).
          </li>
          <li>
            <strong>ילדים:</strong> שם פרטי, שכבת גיל (כיתה), תשובות למבחנים,
            ציונים ונתוני התקדמות בלמידה.
          </li>
          <li>
            <strong>בונוס (אופציונלי):</strong> אם תבחרו בכך, נאסוף את מספר
            ה-WhatsApp של הילד/ה כדי לשלוח שאלות יומיות ולנהל איתם שיח לימודי.
          </li>
        </ul>

        <h2>3. הסכמת הורים ושמירה על ילדים</h2>
        <p>
          האפליקציה מיועדת לילדים בגילאי 6-12.{" "}
          <strong>כל המידע על הילדים מוזן ומנוהל אך ורק על ידי ההורה.</strong>
        </p>
        <ul>
          <li>ההרשמה מתבצעת על ידי ההורה בלבד.</li>
          <li>
            הילדים נכנסים לאפליקציה דרך &ldquo;קישור קסם&rdquo; (Magic Link)
            שנשלח להורה, ללא צורך בשם משתמש או סיסמה עבורם.
          </li>
          <li>
            מסירת מספר WhatsApp של ילד נעשית באישור ובחירה מפורשת של ההורה.
          </li>
        </ul>

        <h2>4. למה אנחנו משתמשים במידע?</h2>
        <p>המידע משמש אך ורק לצרכים הבאים:</p>
        <ul>
          <li>התאמת רמת השאלות לגיל הילד.</li>
          <li>מעקב אחר התקדמות הילד והצגת הציונים להורה.</li>
          <li>שליחת שאלות ב-WhatsApp (אם בחרתם בכך).</li>
          <li>תפעול טכני של האפליקציה.</li>
        </ul>

        <h2>5. שיתוף מידע עם צדדים שלישיים</h2>
        <p>
          אני <strong>לא מוכר</strong> מידע לאף אחד ולא משתמש בו לצרכי שיווק או
          פרסום. מידע מועבר לשירותים הבאים רק כדי שהאפליקציה תוכל לעבוד:
        </p>
        <ul>
          <li>
            <strong>Google OAuth:</strong> לצורך זיהוי והתחברות ההורה באופן
            מאובטח.
          </li>
          <li>
            <strong>Meta (WhatsApp Business API):</strong> לצורך שליחת השאלות
            וקבלת התשובות ב-WhatsApp.
          </li>
          <li>
            <strong>Railway:</strong> ספק אירוח הענן (השרתים נמצאים
            בארה&rdquo;ב/אירופה) שבו מאוחסן בסיס הנתונים (PostgreSQL).
          </li>
          <li>
            <strong>Google Gemini AI:</strong> משמש ליצירת שאלות.{" "}
            <strong>חשוב:</strong> שום מידע אישי על הילד לא נשלח ל-AI, אלא רק
            מילים באנגלית לצורך תרגול או בניית משפט.
          </li>
        </ul>

        <h2>6. עוגיות (Cookies)</h2>
        <p>
          האפליקציה משתמשת ב&ldquo;עוגיות&rdquo; טכניות בלבד כדי לזהות שאתם
          מחוברים למערכת (<code>user_session</code> להורה,{" "}
          <code>child_session</code> לילד). אין באפליקציה עוגיות של פרסומות, מעקב
          (Tracking) או אנליטיקה.
        </p>

        <h2>7. אבטחה ושמירת נתונים</h2>
        <p>
          הנתונים נשמרים בבסיס נתונים מאובטח המאורח בשרתי Railway. אני משתמש
          בשיטות אבטחה מקובלות כדי להגן על המידע, אך חשוב לזכור ששום שירות
          באינטרנט אינו חסין לחלוטין.
        </p>

        <h2>8. הזכויות שלכם</h2>
        <p>
          לפי חוק הגנת הפרטיות, התשמ&rdquo;א-1981, אתם זכאים לעיין במידע שנאסף
          עליכם ועל ילדיכם, לבקש לתקן אותו או למחוק אותו.
        </p>
        <ul>
          <li>
            בכל עת, תוכלו לבקש למחוק את כל המידע על המשפחה שלכם מהמערכת על ידי
            פנייה למייל שלי.
          </li>
          <li>
            המידע יישמר כל עוד חשבונכם פעיל או לפי הצורך לתפעול האפליקציה.
          </li>
        </ul>

        <h2>9. שינויים במדיניות</h2>
        <p>
          אם יהיו שינויים מהותיים באופן שבו אני מטפל במידע, אעדכן את ההורים
          הרשומים במייל.
        </p>

        <p className="privacy-consent">
          המשך שימוש באפליקציה מהווה הסכמה לתנאי מדיניות זו
          ול<a href="/terms">תנאי השימוש</a> שלנו.
        </p>

        <p className="privacy-updated">עודכן לאחרונה: אפריל 2026</p>
      </div>
    </main>
  );
}
